import React, { ChangeEvent } from 'react';
import { Control, Controller } from 'react-hook-form';
import { conformToMask } from 'react-text-mask';
import { IInputProps, Input } from 'src/components/Input/Input';

interface IPhoneMaskInputProps extends IInputProps {
  control: Control;
  required?: boolean;
  defaultValue?: string;
}

const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export function getFormattedPhoneNumber(value: string): string {
  const { conformedValue } = conformToMask(value, phoneNumberMask, {
    guide: false,
  });

  return conformedValue;
}

export function removePhoneNumberFormatting(formattedPhoneNumber = ''): string {
  return formattedPhoneNumber.replace(/[()-\s]/g, '');
}

export function PhoneMaskInput({
  label,
  name,
  id,
  error,
  control,
  required,
  defaultValue = '',
}: IPhoneMaskInputProps): JSX.Element {
  const rules = {
    required: required ? 'Phone number is required' : false,
    pattern: {
      value: /\(\d{3}\)\s\d{3}-\d{4}/,
      message: 'Invalid phone number',
    },
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ value = '', name, onChange, onBlur }) => (
        <Input
          label={label}
          name={name}
          id={id}
          data-testid="phone-number"
          value={value}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(getFormattedPhoneNumber(e.target.value))
          }
          onBlur={onBlur}
          type="tel"
          placeholder="(___)-___-____"
          error={error}
        />
      )}
    />
  );
}
